import React, { useEffect, useState } from "react";
import "./dashboard.scss";
import { motion } from "framer-motion";
import Table from "react-bootstrap/Table";

import { Pagination } from "react-bootstrap";
import useFetchUserStats from "hooks/useFetchUserStats";
import Loader from "utils/loader";
import axios from "axios";
import { API_URL } from "utils/ApiUrl";
import useWeb3 from "hooks/useWeb3";

const Dashboard = () => {
  const web3 = useWeb3();

  const userDashboardStats = useFetchUserStats();
  console.log(userDashboardStats);
  // State to manage referral data, pagination, and loading
  const [rentalHistory, setRentalHistory] = useState([]);
  const [offset, setOffset] = useState(1); // page number
  const [limit] = useState(10); // items per page
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  function formattedDate(blockTimestamp) {
    const date = new Date(blockTimestamp * 1000); // Convert seconds to milliseconds
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  }

  function ConvertedAmount(mweiAmount) {
    const dollarAmount = mweiAmount / 1000000;
    console.log(dollarAmount, "dollar amount");
    return dollarAmount.toFixed(6);
  }

  // Pagination logic
  const handlePageChange = (page) => {
    setOffset(page);
  };

  const fetchRentalHistory = async () => {
    setLoading(true);
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.get(`${API_URL}/claims/rental-claims`, {
        params: { offset, limit },
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "content-type": "application/json",
        },
      });
      const data = await response?.data?.data;
      console.log(data, "rentals");
      setRentalHistory(data.claims);
      setTotalItems(data.count); // Total number of items
      setTotalPages(Math.ceil(data.count / limit));
    } catch (error) {
      console.log(error, "error in rentals");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRentalHistory();
  }, [offset, limit]);

  const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2, // controls one-by-one animation
    },
  },
};

const cardVariants = {
  hidden: {
    opacity: 0,
    y: 50, // start from down
  },
  visible: {
    opacity: 1,
    y: 0, // move up
    transition: {
      duration: 0.5,
      ease: "easeOut",
    },
  },
};
  return (

    <>
      {!userDashboardStats || loading ? (
        <Loader />
      ) : (
        <>
          <div className="content">
            <section className="dashboard-section">
              <div className="mainparent">
                <motion.div
  className="upperside"
  variants={containerVariants}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: false, amount: 0.2 }} // re-trigger on scroll up/down
>
  <motion.div className="totalearningsss" variants={cardVariants}>
    <div className="innerdivsss">
      <div className="shoppingbags">
        <img alt="bag" src="\assets\dashboard\nftpurchased.svg" />
      </div>
      <div>
        <p>Total Fractions Purchased</p>
        <h6>{userDashboardStats?.nftCount}</h6>
      </div>
    </div>
  </motion.div>

  <motion.div className="totalearningsss" variants={cardVariants}>
    <div className="innerdivsss">
      <div className="shoppingbags">
        <img alt="bag" src="\assets\dashboard\AvailableWithdraw.svg" />
      </div>
      <div>
        <p>Total Claimed</p>
        <h6>${userDashboardStats?.withdrawalAmount.toFixed(6)}</h6>
      </div>
    </div>
  </motion.div>

  <motion.div className="totalearningsss" variants={cardVariants}>
    <div className="innerdivsss">
      <div className="shoppingbags">
        <img alt="bag" src="\assets\dashboard\AvailableWithdraw.svg" />
      </div>
      <div>
        <p>Available to Withdraw</p>
        <h6>${userDashboardStats?.pendingwithdrawal.toFixed(6)}</h6>
      </div>
    </div>
  </motion.div>
</motion.div>
                <div className="wraper">
                  <div className="innergraph">
                    <h1 className="nnhgft">Rental Income History</h1>
                    {/* <button className='seebutton'>See All</button> */}
                  </div>
                  <div className="leftside">
                    <div className="Products">
                      <div className="respheight">
                        <div className="tablemains">
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>
                                  <p className="namesvg">
                                    Date
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="8"
                                      height="11"
                                      viewBox="0 0 8 11"
                                      fill="none"
                                    >
                                      <path
                                        d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                        fill="#D3D3D3"
                                      />
                                      <path
                                        d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                        fill="black"
                                      />
                                    </svg>
                                  </p>
                                </th>
                                <th>
                                  <p className="namesvg">
                                    NFT ID
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="8"
                                      height="11"
                                      viewBox="0 0 8 11"
                                      fill="none"
                                    >
                                      <path
                                        d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                        fill="#D3D3D3"
                                      />
                                      <path
                                        d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                        fill="black"
                                      />
                                    </svg>
                                  </p>
                                </th>
                                <th>
                                  <p className="namesvg">Purchased Amount</p>
                                </th>
                                <th>
                                  <p className="namesvg">
                                    Rental Income
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="8"
                                      height="11"
                                      viewBox="0 0 8 11"
                                      fill="none"
                                    >
                                      <path
                                        d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                        fill="#D3D3D3"
                                      />
                                      <path
                                        d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                        fill="black"
                                      />
                                    </svg>
                                  </p>
                                </th>
                                {/* <th><p className='namesvg'>NFT ID<svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11" fill="none">
                              <path d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z" fill="#D3D3D3" />
                              <path d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z" fill="black" />
                            </svg></p></th>
                            <th><p className='namesvg'>Rent<svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11" fill="none">
                              <path d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z" fill="#D3D3D3" />
                              <path d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z" fill="black" />
                            </svg></p></th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {rentalHistory?.length > 0 ? (
                                rentalHistory?.map((rental, index) => (
                                  <tr key={index}>
                                    <td>
                                      <p className="pargraphapple">
                                        {formattedDate(rental?.blockTimestamp)}
                                      </p>
                                    </td>
                                    <td>
                                      <p className="pargraphapple">
                                        #{rental?.nftId}
                                      </p>
                                    </td>
                                    <td>
                                      <p className="pargraphapple">
                                        ${rental?.costPerNft}
                                      </p>
                                    </td>
                                    <td>
                                      <p className="pargraphapple">
                                        ${ConvertedAmount(rental?.amount)}
                                      </p>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="4">
                                    <p className="pargraphapple">
                                      No referrals found.
                                    </p>
                                  </td>
                                </tr>
                              )}
                              <tr></tr>
                            </tbody>
                          </Table>
                          <div className="paginationdiv">
                            <p>
                              {totalItems === 0
                                ? "SHOWING 0 OF 0"
                                : `SHOWING ${
                                    (offset - 1) * limit + 1
                                  }-${Math.min(
                                    offset * limit,
                                    totalItems
                                  )} OF ${totalItems}`}
                            </p>
                            <div className="numberbagidiv">
                              {/* <Pagination>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  className="rightarow"
                                >
                                  <path
                                    opacity="0.2"
                                    d="M5 6.5L8 9.5V3.5L5 6.5Z"
                                    fill="#858585"
                                  />
                                  <path
                                    d="M1.64625 6.85366L4.64625 9.85366C4.74007 9.94748 4.86732 10.0002 5 10.0002C5.13268 10.0002 5.25993 9.94748 5.35375 9.85366C5.44757 9.75984 5.50028 9.63259 5.50028 9.49991C5.50028 9.36722 5.44757 9.23998 5.35375 9.14616L2.70687 6.49991L5.35375 3.85366C5.40021 3.8072 5.43705 3.75205 5.4622 3.69135C5.48734 3.63066 5.50028 3.5656 5.50028 3.49991C5.50028 3.43421 5.48734 3.36915 5.4622 3.30846C5.43705 3.24776 5.40021 3.19261 5.35375 3.14616C5.25993 3.05234 5.13268 2.99963 5 2.99963C4.9343 2.99963 4.86925 3.01257 4.80855 3.03771C4.74786 3.06285 4.69271 3.0997 4.64625 3.14616L1.64625 6.14616C1.59976 6.19259 1.56288 6.24774 1.53772 6.30844C1.51256 6.36913 1.49961 6.4342 1.49961 6.49991C1.49961 6.56561 1.51256 6.63068 1.53772 6.69138C1.56288 6.75207 1.59976 6.80722 1.64625 6.85366ZM4.64625 6.85366L7.64625 9.85366C7.71618 9.92366 7.8053 9.97134 7.90235 9.99067C7.99939 10.01 8.09998 10.0001 8.1914 9.96222C8.28281 9.92434 8.36092 9.86019 8.41586 9.7779C8.4708 9.6956 8.50008 9.59885 8.5 9.49991V7.02303C9.8658 7.14928 11.1353 7.78068 12.0601 8.79366C12.9849 9.80665 13.4984 11.1283 13.5 12.4999C13.5 12.6325 13.5527 12.7597 13.6464 12.8535C13.7402 12.9472 13.8674 12.9999 14 12.9999C14.1326 12.9999 14.2598 12.9472 14.3536 12.8535C14.4473 12.7597 14.5 12.6325 14.5 12.4999C14.4979 10.8631 13.8793 9.28714 12.7674 8.08601C11.6554 6.88488 10.1318 6.14674 8.5 6.01866V3.49991C8.50008 3.40096 8.4708 3.30421 8.41586 3.22191C8.36092 3.13962 8.28281 3.07547 8.1914 3.03759C8.09998 2.99972 7.99939 2.98982 7.90235 3.00914C7.8053 3.02847 7.71618 3.07615 7.64625 3.14616L4.64625 6.14616C4.59976 6.19259 4.56288 6.24774 4.53772 6.30844C4.51256 6.36913 4.49961 6.4342 4.49961 6.49991C4.49961 6.56561 4.51256 6.63068 4.53772 6.69138C4.56288 6.75207 4.59976 6.80722 4.64625 6.85366ZM5.70875 6.49991L7.5 4.70678V8.29303L5.70875 6.49991Z"
                                    fill="#858585"
                                  />
                                </svg>
                                <Pagination.Item active>{1}</Pagination.Item>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  className="leftti"
                                >
                                  <path
                                    opacity="0.2"
                                    d="M11 6.5L8 9.5V3.5L11 6.5Z"
                                    fill="#858585"
                                  />
                                  <path
                                    d="M14.3538 6.85366L11.3538 9.85366C11.2599 9.94748 11.1327 10.0002 11 10.0002C10.8673 10.0002 10.7401 9.94748 10.6462 9.85366C10.5524 9.75984 10.4997 9.63259 10.4997 9.49991C10.4997 9.36722 10.5524 9.23998 10.6462 9.14616L13.2931 6.49991L10.6462 3.85366C10.5998 3.8072 10.5629 3.75205 10.5378 3.69135C10.5127 3.63066 10.4997 3.5656 10.4997 3.49991C10.4997 3.43421 10.5127 3.36915 10.5378 3.30846C10.5629 3.24776 10.5998 3.19261 10.6462 3.14616C10.7401 3.05234 10.8673 2.99963 11 2.99963C11.0657 2.99963 11.1308 3.01257 11.1914 3.03771C11.2521 3.06285 11.3073 3.0997 11.3538 3.14616L14.3538 6.14616C14.4002 6.19259 14.4371 6.24774 14.4623 6.30844C14.4874 6.36913 14.5004 6.4342 14.5004 6.49991C14.5004 6.56561 14.4874 6.63068 14.4623 6.69138C14.4371 6.75207 14.4002 6.80722 14.3538 6.85366ZM11.3538 6.85366L8.35375 9.85366C8.28382 9.92366 8.1947 9.97134 8.09765 9.99067C8.00061 10.01 7.90002 10.0001 7.8086 9.96222C7.71719 9.92434 7.63908 9.86019 7.58414 9.7779C7.5292 9.6956 7.49992 9.59885 7.5 9.49991V7.02303C6.1342 7.14928 4.86467 7.78068 3.93989 8.79366C3.01511 9.80665 2.50165 11.1283 2.5 12.4999C2.5 12.6325 2.44732 12.7597 2.35355 12.8535C2.25979 12.9472 2.13261 12.9999 2 12.9999C1.86739 12.9999 1.74021 12.9472 1.64645 12.8535C1.55268 12.7597 1.5 12.6325 1.5 12.4999C1.50205 10.8631 2.12068 9.28714 3.23262 8.08601C4.34457 6.88488 5.86821 6.14674 7.5 6.01866V3.49991C7.49992 3.40096 7.5292 3.30421 7.58414 3.22191C7.63908 3.13962 7.71719 3.07547 7.8086 3.03759C7.90002 2.99972 8.00061 2.98982 8.09765 3.00914C8.1947 3.02847 8.28382 3.07615 8.35375 3.14616L11.3538 6.14616C11.4002 6.19259 11.4371 6.24774 11.4623 6.30844C11.4874 6.36913 11.5004 6.4342 11.5004 6.49991C11.5004 6.56561 11.4874 6.63068 11.4623 6.69138C11.4371 6.75207 11.4002 6.80722 11.3538 6.85366ZM10.2913 6.49991L8.5 4.70678V8.29303L10.2913 6.49991Z"
                                    fill="#858585"
                                  />
                                </svg>
                              </Pagination> */}

                              <Pagination>
                                <Pagination.Prev
                                  onClick={() => {
                                    if (totalItems > 0)
                                      handlePageChange(Math.max(1, offset - 1));
                                  }}
                                  disabled={offset === 1 || totalItems === 0}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    className="rightarow"
                                  >
                                    <path
                                      opacity="0.2"
                                      d="M5 6.5L8 9.5V3.5L5 6.5Z"
                                      fill="#858585"
                                    />
                                    <path
                                      d="M1.64625 6.85366L4.64625 9.85366C4.74007 9.94748 4.86732 10.0002 5 10.0002C5.13268 10.0002 5.25993 9.94748 5.35375 9.85366C5.44757 9.75984 5.50028 9.63259 5.50028 9.49991C5.50028 9.36722 5.44757 9.23998 5.35375 9.14616L2.70687 6.49991L5.35375 3.85366C5.40021 3.8072 5.43705 3.75205 5.4622 3.69135C5.48734 3.63066 5.50028 3.5656 5.50028 3.49991C5.50028 3.43421 5.48734 3.36915 5.4622 3.30846C5.43705 3.24776 5.40021 3.19261 5.35375 3.14616C5.25993 3.05234 5.13268 2.99963 5 2.99963C4.9343 2.99963 4.86925 3.01257 4.80855 3.03771C4.74786 3.06285 4.69271 3.0997 4.64625 3.14616L1.64625 6.14616C1.59976 6.19259 1.56288 6.24774 1.53772 6.30844C1.51256 6.36913 1.49961 6.4342 1.49961 6.49991C1.49961 6.56561 1.51256 6.63068 1.53772 6.69138C1.56288 6.75207 1.59976 6.80722 1.64625 6.85366ZM4.64625 6.85366L7.64625 9.85366C7.71618 9.92366 7.8053 9.97134 7.90235 9.99067C7.99939 10.01 8.09998 10.0001 8.1914 9.96222C8.28281 9.92434 8.36092 9.86019 8.41586 9.7779C8.4708 9.6956 8.50008 9.59885 8.5 9.49991V7.02303C9.8658 7.14928 11.1353 7.78068 12.0601 8.79366C12.9849 9.80665 13.4984 11.1283 13.5 12.4999C13.5 12.6325 13.5527 12.7597 13.6464 12.8535C13.7402 12.9472 13.8674 12.9999 14 12.9999C14.1326 12.9999 14.2598 12.9472 14.3536 12.8535C14.4473 12.7597 14.5 12.6325 14.5 12.4999C14.4979 10.8631 13.8793 9.28714 12.7674 8.08601C11.6554 6.88488 10.1318 6.14674 8.5 6.01866V3.49991C8.50008 3.40096 8.4708 3.30421 8.41586 3.22191C8.36092 3.13962 8.28281 3.07547 8.1914 3.03759C8.09998 2.99972 7.99939 2.98982 7.90235 3.00914C7.8053 3.02847 7.71618 3.07615 7.64625 3.14616L4.64625 6.14616C4.59976 6.19259 4.56288 6.24774 4.53772 6.30844C4.51256 6.36913 4.49961 6.4342 4.49961 6.49991C4.49961 6.56561 4.51256 6.63068 4.53772 6.69138C4.56288 6.75207 4.59976 6.80722 4.64625 6.85366ZM5.70875 6.49991L7.5 4.70678V8.29303L5.70875 6.49991Z"
                                      fill="#858585"
                                    />
                                  </svg>
                                </Pagination.Prev>
                                {/* Pagination Items */}
                                {totalPages <= 5 ? (
                                  [...Array(totalPages)].map((_, i) => (
                                    <Pagination.Item
                                      key={i}
                                      active={i + 1 === offset}
                                      onClick={() => handlePageChange(i + 1)}
                                    >
                                      {i + 1}
                                    </Pagination.Item>
                                  ))
                                ) : (
                                  // Handle ellipsis for large number of pages
                                  <>
                                    <Pagination.Item
                                      active={offset === 1}
                                      onClick={() => handlePageChange(1)}
                                    >
                                      1
                                    </Pagination.Item>
                                    {offset > 3 && (
                                      <Pagination.Ellipsis disabled />
                                    )}
                                    {offset === 1 || offset === totalPages
                                      ? [...Array(3)].map((_, i) => {
                                          const page =
                                            offset === 1
                                              ? i + 1
                                              : totalPages - 3 + i + 1;
                                          return (
                                            <Pagination.Item
                                              key={page}
                                              active={page === offset}
                                              onClick={() =>
                                                handlePageChange(page)
                                              }
                                            >
                                              {page}
                                            </Pagination.Item>
                                          );
                                        })
                                      : [...Array(3)].map((_, i) => {
                                          const page = offset - 1 + i;
                                          return (
                                            <Pagination.Item
                                              key={page}
                                              active={page === offset}
                                              onClick={() =>
                                                handlePageChange(page)
                                              }
                                            >
                                              {page}
                                            </Pagination.Item>
                                          );
                                        })}
                                    {offset < totalPages - 2 && (
                                      <Pagination.Ellipsis disabled />
                                    )}
                                    <Pagination.Item
                                      active={offset === totalPages}
                                      onClick={() =>
                                        handlePageChange(totalPages)
                                      }
                                    >
                                      {totalPages}
                                    </Pagination.Item>
                                  </>
                                )}
                                <Pagination.Next
                                  onClick={() => {
                                    if (totalItems > 0)
                                      handlePageChange(
                                        Math.min(totalPages, offset + 1)
                                      );
                                  }}
                                  disabled={
                                    offset === totalPages || totalItems === 0
                                  }
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    className="leftti"
                                  >
                                    <path
                                      opacity="0.2"
                                      d="M11 6.5L8 9.5V3.5L11 6.5Z"
                                      fill="#858585"
                                    />
                                    <path
                                      d="M14.3538 6.85366L11.3538 9.85366C11.2599 9.94748 11.1327 10.0002 11 10.0002C10.8673 10.0002 10.7401 9.94748 10.6462 9.85366C10.5524 9.75984 10.4997 9.63259 10.4997 9.49991C10.4997 9.36722 10.5524 9.23998 10.6462 9.14616L13.2931 6.49991L10.6462 3.85366C10.5998 3.8072 10.5629 3.75205 10.5378 3.69135C10.5127 3.63066 10.4997 3.5656 10.4997 3.49991C10.4997 3.43421 10.5127 3.36915 10.5378 3.30846C10.5629 3.24776 10.5998 3.19261 10.6462 3.14616C10.7401 3.05234 10.8673 2.99963 11 2.99963C11.0657 2.99963 11.1308 3.01257 11.1914 3.03771C11.2521 3.06285 11.3073 3.0997 11.3538 3.14616L14.3538 6.14616C14.4002 6.19259 14.4371 6.24774 14.4623 6.30844C14.4874 6.36913 14.5004 6.4342 14.5004 6.49991C14.5004 6.56561 14.4874 6.63068 14.4623 6.69138C14.4371 6.75207 14.4002 6.80722 14.3538 6.85366ZM11.3538 6.85366L8.35375 9.85366C8.28382 9.92366 8.1947 9.97134 8.09765 9.99067C8.00061 10.01 7.90002 10.0001 7.8086 9.96222C7.71719 9.92434 7.63908 9.86019 7.58414 9.7779C7.5292 9.6956 7.49992 9.59885 7.5 9.49991V7.02303C6.1342 7.14928 4.86467 7.78068 3.93989 8.79366C3.01511 9.80665 2.50165 11.1283 2.5 12.4999C2.5 12.6325 2.44732 12.7597 2.35355 12.8535C2.25979 12.9472 2.13261 12.9999 2 12.9999C1.86739 12.9999 1.74021 12.9472 1.64645 12.8535C1.55268 12.7597 1.5 12.6325 1.5 12.4999C1.50205 10.8631 2.12068 9.28714 3.23262 8.08601C4.34457 6.88488 5.86821 6.14674 7.5 6.01866V3.49991C7.49992 3.40096 7.5292 3.30421 7.58414 3.22191C7.63908 3.13962 7.71719 3.07547 7.8086 3.03759C7.90002 2.99972 8.00061 2.98982 8.09765 3.00914C8.1947 3.02847 8.28382 3.07615 8.35375 3.14616L11.3538 6.14616C11.4002 6.19259 11.4371 6.24774 11.4623 6.30844C11.4874 6.36913 11.5004 6.4342 11.5004 6.49991C11.5004 6.56561 11.4874 6.63068 11.4623 6.69138C11.4371 6.75207 11.4002 6.80722 11.3538 6.85366ZM10.2913 6.49991L8.5 4.70678V8.29303L10.2913 6.49991Z"
                                      fill="#858585"
                                    />
                                  </svg>
                                </Pagination.Next>
                              </Pagination>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      )}
    </>
  );
};

export default Dashboard;
